import { render, staticRenderFns } from "./TheSkeletonLoader.vue?vue&type=template&id=64dca75d&"
import script from "./TheSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./TheSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./TheSkeletonLoader.vue?vue&type=style&index=0&id=64dca75d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports